const initialState = {
  loaded: false,
  error: null,
  data: Object.create(null),
}

export default initialState
